var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "modal" }, [
    _c(
      "div",
      {
        ref: "catalogShareModal",
        staticClass: "modal fade catalog-share-modal",
        attrs: {
          id: "catalogShareModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "catalogShareModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-xl catalog-share-modal__dialog",
            attrs: { role: "document" },
          },
          [
            _c(
              "div",
              { staticClass: "modal-content catalog-share-modal__content" },
              [
                _c(
                  "div",
                  { staticClass: "modal-header catalog-share-modal__header" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close catalog-share-modal__close",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: { click: _vm.closeHandler },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×"),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body catalog-share-modal__body" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "input-group catalog-share-modal__link-group",
                      },
                      [
                        _c("input", {
                          staticClass:
                            "form-control catalog-share-modal__link-input",
                          attrs: { type: "text", readonly: "" },
                          domProps: { value: _vm.shareUrl },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary catalog-share-modal__copy-button",
                            attrs: { type: "button" },
                            on: { click: _vm.copyLink },
                          },
                          [
                            _c("i", { staticClass: "fa fa-copy" }),
                            _vm._v("\n              Copy\n            "),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "catalog-share-modal__qr" }, [
                      _vm.qrUrl
                        ? _c("img", {
                            staticClass: "catalog-share-modal__qr-image",
                            attrs: { src: _vm.qrUrl, alt: "Catalog QR code" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn catalog-share-modal__download-button",
                          attrs: { type: "button" },
                          on: { click: _vm.downloadQr },
                        },
                        [_vm._v("\n              Download PNG\n            ")]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "catalog-share-modal__header-content" }, [
      _c(
        "h5",
        {
          staticClass: "modal-title catalog-share-modal__title",
          attrs: { id: "catalogShareModalLabel" },
        },
        [_vm._v("\n              Share Flipbook\n            ")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "catalog-share-modal__description" }, [
        _vm._v(
          "\n              Copy the link or share the QR code so anyone can view this Flipbook on their device.\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "catalog-share-modal__qr-content" }, [
      _c("div", { staticClass: "catalog-share-modal__qr-title" }, [
        _c("i", { staticClass: "bi bi-qr-code catalog-share-modal__qr-icon" }),
        _vm._v("\n                Scan to open on a phone\n              "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "catalog-share-modal__qr-description" }, [
        _vm._v(
          "\n                Great for trade shows or printed collateral.\n              "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }